module.exports = __webpack_public_path__ + "static/img/03.9418e5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/hugelshofer/03.jpg
// module id = 390
// module chunks = 1